// «Написать разработчикам» (Настройки): типы, проверка текста, контакт для ответа, технические данные.
// Сервер (data_service/services/feedback.py) проверяет то же и берёт активный сервер сам.

export const FEEDBACK_TYPES = [
  { value: 'problem', label: 'Проблема', hint: 'Что-то не работает или считает не так' },
  { value: 'idea', label: 'Идея', hint: 'Чего не хватает в приложении' },
  { value: 'question', label: 'Вопрос', hint: 'Как что-то сделать или где найти' },
];

export const TEXT_MIN = 5;
export const TEXT_MAX = 2000;
export const CONTACT_MAX = 200;

// Ник Telegram; у входа через Telegram без ника username — заглушка tg_<id>
const TELEGRAM_NICK = /^[A-Za-z][A-Za-z0-9_]{4,31}$/;

export const telegramNick = (username) =>
  username && !username.startsWith('tg_') && TELEGRAM_NICK.test(username) ? username : null;

// Без почты (вход через Telegram) спрашиваем, как связаться; ник — сразу в поле
export const contactPrefill = ({ email, username }) => {
  if (email) return null;
  const nick = telegramNick(username);
  return nick ? `@${nick}` : '';
};

export const textError = (text) => {
  const length = text.trim().length;
  if (length < TEXT_MIN) return `Напишите хотя бы ${TEXT_MIN} символов`;
  if (length > TEXT_MAX) return `Не больше ${TEXT_MAX} символов`;
  return null;
};

// Технические данные — только если пользователь разрешил; сервер добавит бэкенд (активный)
export const collectContext = ({ version, telegram, standalone, userAgent, screen }) => {
  const context = {
    platform: telegram ? 'Telegram' : standalone ? 'Приложение' : 'Браузер',
    device: (userAgent || '').slice(0, 300),
  };
  if (version) context.version = version;
  if (screen?.width && screen?.height) context.screen = `${screen.width}×${screen.height}`;
  return context;
};

// Что увидит пользователь под галочкой «Приложить технические данные»
export const contextPreview = (context, serverName) =>
  [
    context.version && `версия ${context.version}`,
    context.platform,
    context.screen && `экран ${context.screen}`,
    'устройство и браузер',
    serverName && `сервер «${serverName}»`,
  ]
    .filter(Boolean)
    .join(' · ');

export const successText = (replyVia) => {
  if (replyVia === 'email') return 'Спасибо! Получили. Если понадобится, ответим на почту.';
  if (replyVia === 'telegram') return 'Спасибо! Получили. Если понадобится, ответим в Telegram.';
  return 'Спасибо! Получили.';
};
